export class UserNotificationPreferences {
    constructor(
        public venueId: string,
        public bookingRequests: boolean
    ) { }
}
